enum QueryType {
  startSession = "START_SESSION",
  getConference = "GET_CONFERENCE",
  createConference = "CREATE_CONFERENCE",
  updateConference = "UPDATE_CONFERENCE",
  endSession = "END_SESSION",
}

export default QueryType;
